import type { SearchSpacesParams } from './space.api';

export const spaceKeys = {
  all: ['spaces'] as const,
  checkCode: (code: string): readonly unknown[] => [...spaceKeys.all, 'check-code', code] as const,
  detail: (id: string): readonly unknown[] => [...spaceKeys.all, 'detail', id] as const,
  search: (params: SearchSpacesParams): readonly unknown[] => [...spaceKeys.all, 'search', params] as const,
  withSites: (): readonly unknown[] => [...spaceKeys.all, 'with-sites'] as const,
};
